import { Component } from '@angular/core';

@Component({
  selector: 'curbnturf-display-validation-errors-submit-button',
  templateUrl: './display-validation-errors-submit-button.component.html',
  styleUrls: ['./display-validation-errors-submit-button.component.scss'],
  standalone: true,
})
export class DisplayValidationErrorsSubmitButtonComponent {}
